import React, { useState } from "react";
import FaqData from "./Faq.json";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index, event) => {
    event.preventDefault();
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className=" flex flex-col  justify-center items-center px-4" id="faq">
      <div className="lg:w-[1300px] w-screen flex flex-col lg:gap-12 gap-8 items-center justify-center px-[100px] pt-12 pb-24 bg-[#F7F9FA] rounded-[52px]">
        <h3 className="lg:text-4xl text-[28px] font-semibold text-[#364763] text-center">
          Frequently Asked questions
        </h3>
        <div className="lg:w-[1200px] w-[345px] flex gap-4 flex-col">
          {FaqData.map((data, index) => (
            <details
              key={data.id}
              open={openIndex === index} // Open only the active one
              className="group py-6 px-[30px] [&_summary::-webkit-details-marker]:hidden rounded-[30px]  border border-[#DDE3ED] bg-white"
              onClick={(e) => toggleFAQ(index, e)}
            >
              <summary className="flex cursor-pointer items-center justify-between gap-1.5 ">
                <h2 className="lg:text-xl text-base font-semibold text-[#606C80] ">
                  {data.heading}
                </h2>

                <span className="relative lg:size-11 size-6 text-white flex justify-center items-center lg:text-3xl text-base shrink-0 bg-[#01120A] rounded-full">
                  {openIndex === index ? "−" : "+"}
                </span>
              </summary>

              <p className="mt-4 leading-relaxed text-[#94A0B3] lg:text-lg text-xs font-medium border-t border-[#DDE3ED] pt-2">
                {data.desc}
              </p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
